import { useIntl } from 'react-intl';
import { z } from 'zod';
import { useAppForm } from '~/components/Form';
import formMessages from '~/components/form-messages';
import messages from './messages';
import styles from './styles.module.css';

type EditTitleFormValues = {
  title: string;
};

type EditTitleFormProps = {
  onSubmit: (values: EditTitleFormValues) => void;
  initialValues?: Partial<EditTitleFormValues>;
};

export const EditTitleForm = ({
  onSubmit,
  initialValues,
}: EditTitleFormProps) => {
  const intl = useIntl();

  const schema = z.object({
    title: z.string({
      error: intl.formatMessage(formMessages.required),
    }),
  });

  const form = useAppForm({
    defaultValues: {
      title: '',
      ...initialValues,
    } as EditTitleFormValues,
    validators: {
      onChange: schema,
    },
    onSubmit: ({ value }) => onSubmit(value),
  });

  return (
    <form
      id="edit-title-form"
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
      className={styles.form}
    >
      <form.AppField name="title">
        {(field) => (
          <field.TextField
            label={intl.formatMessage(messages.titleLabel)}
            fullWidth
          />
        )}
      </form.AppField>
    </form>
  );
};

export default EditTitleForm;
